import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import urlResolver from 'edrolo/utils/URLResolver';
import cx from 'classnames';
import pluralize from 'pluralize';
import { enums } from 'edrolo-ui';
import s from './styles.scss';

export const Gradient = ({
  className,
  width,
}: {
  width?: enums.Size;
  className?: string;
}) => (
  <div
    role="img"
    aria-label="loading"
    aria-busy
    className={cx(s.gradient, width && s[width], className)}
  />
);

export const Thumbnail = () => (
  <div role="img" aria-label="loading" aria-busy className={cx(s.thumbnail)} />
);

export const Spinner = ({ className }: { className?: string }) => (
  <span
    role="img"
    aria-label="loading"
    aria-busy
    className={cx(s.spinner, className)}
  />
);

export const RedirectingSpinner = ({
  className,
  shouldRedirect = true,
  redirectUrl = urlResolver.reverse('courses-page'),
  redirectMessage = 'Redirecting to the subjects page',
  delayInSeconds = 5,
  renderLoadingIndicator = () => (
    <div>Oops something went wrong. Please try again later.</div>
  ),
}: {
  className?: string;
  shouldRedirect?: boolean;
  redirectUrl?: string;
  redirectMessage?: string;
  delayInSeconds?: number;
  renderLoadingIndicator?: () => React.ReactNode;
}) => {
  const history = useHistory();
  const [secondsRemaining, setSecondsRemaining] = useState(delayInSeconds);

  useEffect(() => {
    if (shouldRedirect) {
      const timer = setInterval(() => {
        setSecondsRemaining((prev) => prev - 1);
      }, 1000);

      const redirectTimer = setTimeout(() => {
        history.push(redirectUrl);
      }, delayInSeconds * 1000);

      // Cleanup the timers if the component unmounts
      return () => {
        clearInterval(timer);
        clearTimeout(redirectTimer);
      };
    }

    // Return a no-op cleanup function if shouldRedirect is false
    return () => {};
  }, [shouldRedirect, redirectUrl, delayInSeconds, history]);

  return (
    <div>
      {renderLoadingIndicator()}
      {shouldRedirect && (
        <span className={cx(className)}>
          {`${redirectMessage} in ${secondsRemaining} ${pluralize(
            'second',
            secondsRemaining
          )} ...`}
        </span>
      )}
    </div>
  );
};
